module.exports = {"445303100":"六都镇","445303101":"高村镇","445303102":"白石镇","445303103":"镇安镇","445303104":"富林镇","445303105":"石城镇","445303106":"都杨镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/445303.json
// module id = 2191
// module chunks = 0